import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {format} from 'date-fns'
import * as React from 'react'
import {useFragment} from 'react-relay'








import Avatar from '../../../../components/Avatar/Avatar'
import RowActions from '../../../../components/Row/RowActions'
import RowInfo from '../../../../components/Row/RowInfo'
import RowInfoHeader from '../../../../components/Row/RowInfoHeader'
import RowInfoHeading from '../../../../components/Row/RowInfoHeading'
import RowInfoLink from '../../../../components/Row/RowInfoLink'
import BaseTag from '../../../../components/Tag/BaseTag'
import InactiveTag from '../../../../components/Tag/InactiveTag'
import RoleTag from '../../../../components/Tag/RoleTag'
import useModal from '../../../../hooks/useModal'
import defaultUserAvatar from '../../../../styles/theme/images/avatar-user.svg'
import lazyPreload from '../../../../utils/lazyPreload'

const ActionsBlock = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end'
})










const LeaveOrgModal = lazyPreload(
  () => import(/* webpackChunkName: 'LeaveOrgModal' */ '../LeaveOrgModal/LeaveOrgModal')
)

const OrgAdminActionMenu = lazyPreload(
  () =>
    import(/* webpackChunkName: 'OrgAdminActionMenu' */ '../../../../components/OrgAdminActionMenu')
)

const RemoveFromOrgModal = lazyPreload(
  () =>
    import(/* webpackChunkName: 'RemoveFromOrgModal' */ '../RemoveFromOrgModal/RemoveFromOrgModal')
)





const UserAvatar = ({picture}) => (
  _jsx('div', { className: "mr-4 hidden md:block"  , children: 
    picture ? (
      _jsx(Avatar, { picture: picture, className: "h-11 w-11" ,} )
    ) : (
      _jsx('img', { alt: "default avatar" , src: defaultUserAvatar,} )
    )
  })
)









const UserInfo = ({preferredName, email, isBillingLeader, isOrgAdmin, inactive}) => (
  _jsxs(RowInfo, { className: "pl-0", children: [
    _jsxs(RowInfoHeader, { children: [
      _jsx(RowInfoHeading, { children: preferredName})
      , isBillingLeader && _jsx(RoleTag, { children: "Billing Leader" })
      , isOrgAdmin && _jsx(BaseTag, { className: "bg-gold-500 text-white" , children: "Org Admin" })
      , inactive && !isBillingLeader && !isOrgAdmin && _jsx(InactiveTag, { children: "Inactive"})
    ]})
    , _jsx(RowInfoLink, { href: `mailto:${email}`, title: "Send an email"  , children: 
      email
    })
  ]})
)






const UserActions = ({organizationUser, organization}) => {
  const {id: orgId} = organization
  const {
    user: {id: userId}
  } = organizationUser
  const {
    togglePortal: toggleLeave,
    modalPortal: leaveModal,
    closePortal: closeLeaveModal
  } = useModal()
  const {
    togglePortal: toggleRemove,
    modalPortal: removeModal,
    closePortal: closeRemoveModal
  } = useModal()

  // For the RemoveFromOrgModal
  const organizationUserForModal = [organizationUser]

  return (
    _jsx(RowActions, { children: 
      _jsxs(ActionsBlock, { children: [
        _jsx(OrgAdminActionMenu, {
          organization: organization,
          organizationUser: organizationUser,
          toggleLeave: toggleLeave,
          toggleRemove: toggleRemove,}
        )
        , leaveModal(_jsx(LeaveOrgModal, { orgId: orgId, closePortal: closeLeaveModal,} ))
        , removeModal(
          _jsx(RemoveFromOrgModal, {
            orgId: orgId,
            userIds: [userId],
            organizationUsers: organizationUserForModal,
            closePortal: closeRemoveModal,}
          )
        )
      ]})
    })
  )
}

const OrgMemberRow = (props) => {
  const {
    organizationUser: organizationUserRef,
    organization: organizationRef,
    isSelected = false,
    onSelectUser
  } = props

  const organization = useFragment(
    graphql`
      fragment OrgMemberRow_organization on Organization {
        id
        isOrgAdmin
        ...OrgAdminActionMenu_organization
      }
    `,
    organizationRef
  )

  const organizationUser = useFragment(
    graphql`
      fragment OrgMemberRow_organizationUser on OrganizationUser {
        id
        user {
          id
          email
          inactive
          picture
          preferredName
          lastSeenAt
        }
        role
        ...OrgAdminActionMenu_organizationUser
        ...RemoveFromOrgModal_organizationUsers
      }
    `,
    organizationUserRef
  )

  const {
    user: {email, inactive, picture, preferredName, lastSeenAt},
    role
  } = organizationUser

  const isBillingLeader = role === 'BILLING_LEADER'
  const isOrgAdmin = role === 'ORG_ADMIN'
  const {isOrgAdmin: isViewerOrgAdmin} = organization
  const formattedLastSeenAt = lastSeenAt ? format(new Date(lastSeenAt), 'yyyy-MM-dd') : 'Never'

  const handleCheckboxChange = (e) => {
    _optionalChain([onSelectUser, 'optionalCall', _ => _(organizationUser.user.id, e.target.checked)])
  }

  return (
    _jsxs('tr', { className: "border-b border-slate-300 last:border-b-0"  , children: [
      _jsx('td', { className: "px-2 py-3 align-middle"  , children: 
        _jsx('div', { className: "flex items-center justify-center"  , children: 
          isViewerOrgAdmin && (
            _jsx('input', {
              type: "checkbox",
              checked: isSelected,
              onChange: handleCheckboxChange,
              className: "h-4 w-4 rounded border-slate-300 text-grape-700 focus:ring-grape-500"     ,}
            )
          )
        })
      })
      , _jsx('td', { className: "w-1/2 px-2 py-3 align-middle"   , children: 
        _jsxs('div', { className: "flex w-full items-center overflow-hidden"   , children: [
          _jsx(UserAvatar, { picture: picture,} )
          , _jsx('div', { className: "min-w-0 grow" , children: 
            _jsx(UserInfo, {
              preferredName: preferredName,
              email: email,
              isBillingLeader: isBillingLeader,
              isOrgAdmin: isOrgAdmin,
              inactive: inactive,}
            )
          })
        ]})
      })
      , _jsx('td', { className: "w-3/10 px-2 py-3 align-middle"   , children: 
        _jsx(RowInfo, { className: "pl-0", children: formattedLastSeenAt})
      })
      , _jsx('td', { className: "w-1/5 px-2 py-3 align-middle"   , children: 
        _jsx(UserActions, { organizationUser: organizationUser, organization: organization,} )
      })
    ]})
  )
}

export default OrgMemberRow
